import { ListGrid } from "./ListGrid";
import { ListRoot } from "./ListRoot";

export const List = {
  Root: ListRoot,
  Grid: ListGrid,
};
